import getImage from './image'
import getDivider from './divider'

export default {
    getImage,
    getDivider
}


// WEBPACK FOOTER //
// ./src/atomic/index.ts